import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.categoryId = ''
      this.materialNo = ''
      this.deviceId = ''
      this.supplierId = ''
    }
  }
}
export default searchFrom
